// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ABKF","label":"styles_label__PP2nQ"};